(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_banner-parent"] && !Shopify.designMode) return;
  try {
    function initBannerGrid() {
    const bannerParents = document.querySelectorAll('.banner-parent');
    bannerParents.forEach(function (bannerParent) {
      const bannerItems = bannerParent.querySelectorAll('.banner-item');
      bannerParent.classList.add('grid-' + bannerItems.length);
    });
  }

  initBannerGrid();  
  if (Shopify.designMode || Shopify.visualPreviewMode) {
    document.addEventListener('shopify:section:select', initBannerGrid);
    document.addEventListener('shopify:section:deselect', initBannerGrid);
    document.addEventListener('shopify:section:reorder', initBannerGrid);
    document.addEventListener('shopify:block:select', initBannerGrid);
    document.addEventListener('shopify:block:deselect', initBannerGrid);
    document.addEventListener('shopify:section:load', initBannerGrid);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_group-media-content"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('teslica-dealer-application')) {
    customElements.define('teslica-dealer-application', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        this.addEventListener('click', (event) => {
          const trigger = event.target.closest('a[href="#dealer-application"]');
          if (!trigger || !this.contains(trigger)) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.openApplication(trigger);
        }, { capture: true, signal: this.events.signal });
      }
      openApplication(trigger) {
        const dialog = this.querySelector('.teslica-dealer-dialog');
        if (!dialog || dialog.open) return;
        if (!this.dialog) {
          this.dialog = dialog;
          const options = { signal: this.events.signal };
          dialog.querySelector('[data-dealer-close]').addEventListener('click', () => dialog.close(), options);
          dialog.addEventListener('close', () => this.restorePage(), options);
        }
        this.opener = trigger;
        const frame = dialog.querySelector('iframe');
        if (!frame.hasAttribute('src')) frame.src = frame.dataset.formSrc;
        this.previousOverflow = document.documentElement.style.overflow;
        dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
      }
      restorePage() {
        if (this.previousOverflow !== undefined) {
          document.documentElement.style.overflow = this.previousOverflow;
          this.previousOverflow = undefined;
        }
        if (this.opener && this.opener.isConnected) this.opener.focus({ preventScroll: true });
        this.opener = null;
      }
      disconnectedCallback() {
        if (!this.events) return;
        this.events.abort();
        this.events = null;
        if (this.dialog && this.dialog.open) this.dialog.close();
        this.restorePage();
        this.dialog = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_slide-parent"] && !Shopify.designMode) return;
  try {
    function addAnimateDelayToSlides() {
    const swiperWrappers = document.querySelectorAll('.swiper-wrapper_parent');
    swiperWrappers.forEach(function(swiperWrapper) {
      const slideItems = swiperWrapper.querySelectorAll('.swiper-slide_item');
      slideItems.forEach(function(slideItem, index) {
        if (index > 0) {
          const contentSlides = slideItem.querySelectorAll('.content-slide');
          contentSlides.forEach(function(contentSlide) {
            contentSlide.classList.add('animate-delay');
          });
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', addAnimateDelayToSlides);
  if (Shopify.designMode || Shopify.visualPreviewMode) {
    document.addEventListener('shopify:section:select', addAnimateDelayToSlides);
    document.addEventListener('shopify:section:deselect', addAnimateDelayToSlides);
    document.addEventListener('shopify:section:reorder', addAnimateDelayToSlides);
    document.addEventListener('shopify:block:select', addAnimateDelayToSlides);
    document.addEventListener('shopify:block:deselect', addAnimateDelayToSlides);
    document.addEventListener('shopify:section:load', addAnimateDelayToSlides);
  }
  } catch(e) { console.error(e); }
})();

})();
